/**
 * @file
 * This file contains the redux reducer and exports a redux store.
 */

import { applyMiddleware, combineReducers, createStore, Store } from 'redux'

import { sentryMiddleware } from 'student/shared/util/logging-middleware'
import createObserver from 'student/shared/util/redux-observer'
import { location, order, ui } from './reducers'
/**
 * The main redux reducer. It takes in the state and an action and returns a new
 * object that represents the altered application state.
 *
 * @param   {Object} state
 * @param   {Object} action
 * @returns {Object}
 */

export const observer = createObserver()

export const checkout = combineReducers({
  location,
  ui,
  order,
})

const generateStore = () =>
  (createStore(
    checkout,
    applyMiddleware(observer.middleware, sentryMiddleware)
  ) as unknown) as Store<any>

if (!window.store) window.store = generateStore()
export const store = window.store
